module.exports = __webpack_public_path__ + "img/menu_ladies_dermapen.101a363f.png";